<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="$router.back()">
                        <img src="@/assets/common/hd_prev_btn.png" alt="" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <div id="user_form">
                    <div class="result_txt">
                        <b>회원 가입 완료되었습니다.</b> <br>
                        승인 완료 시 이메일로 안내 드리겠습니다.
                    </div>
                    <button type="button" id="submit_btn" @click="$router.push('/login')">로그인</button>
                    <p class="check_form_info">관리자 승인 이후 서비스 이용이 가능합니다.</p>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
</template>
<script lang="ts" config>
import {
    HeaderLayout,
    GnbLayout,
    router
} from "@/BaseComponent";

export default {
    components: {
        HeaderLayout,
        GnbLayout,
    },
    setup() {

        return {
            router
        };
    },
};
</script>
